export const explore_menu_data= [
    {
      label: "About Us",
      url: "/explore-telecel/",
      children: [
      ],
    },
    {
      label: "Executive Team",
      url: "/explore-telecel/executive-team/",
      children: [
      ],
    },
    // {
    //   label: "Corporate Social Responsibility",
    //   url: "#",
    //   children: [
    //   ],
    // },
  ]